import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import TabsOrgao from '../components/TabsOrgao'

import api from '../services/api'
import { paramsToObject, onlyNumbers } from '../utils/functions'
import { mCNPJ, mTel, mCEP } from '../utils/masks'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function RegOrgao() {
  const [data, setData] = useState([{ ativo: 'S' }])
  const [dataUnidades, setDataUnidades] = useState([])
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboCidades, setComboCidades] = useState([{ value: '', display: '' }])
  const [comboTipo, setComboTipo] = useState([{ value: '', display: '' }])
  const [comboSituacao, setComboSituacao] = useState([{ value: '', display: '' }])
  const [codigo, setCodigo] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboSituacao(await api.getComboData('situacao_padrao'))  
      setComboCidades(await api.getComboData('cidades'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Orgao', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Orgao', 'Inclusao'))
      }

      if (query.codigo > 0) {
        setUpdateType(true)
        setCodigo(query.codigo)
        api.get('/orgao?pk_org=' + query.codigo).then(r => {
          if (r.data[0]) {
            r.data[0].cnpj = mCNPJ(r.data[0].cnpj || '')
            r.data[0].cep = mCEP(r.data[0].cep || '')
            r.data[0].fone1 = mTel(r.data[0].fone1 || '')
            r.data[0].fone2 = mTel(r.data[0].fone2 || '')
            r.data[0].celular = mTel(r.data[0].celular || '')
            setData(r.data[0])
            api.get('/orgao_unidade?fk_org=' + query.codigo).then(r => {
              if (r.data) {
                console.log(r.data)
                setDataUnidades(r.data)
              }
              swal.close()
            })

          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao',
      'cnpj',
      'logradouro',
      'numero',
      'fk_cid',
      'bairro',
      'cep'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr === 'fk_cid') fieldName = 'cidade' 
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          auxValues.cnpj = onlyNumbers(auxValues.cnpj)
          auxValues.cep = onlyNumbers(auxValues.cep)
          auxValues.fone1 = onlyNumbers(auxValues.fone1)
          auxValues.fone2 = onlyNumbers(auxValues.fone2)
          auxValues.celular = onlyNumbers(auxValues.celular)
          if (updateType) {
            api.post('/orgao/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/orgao/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'cnpj': 
        auxValues[e.target.name] = mCNPJ(e.target.value);
      break

      case 'cep': 
        auxValues[e.target.name] = mCEP(e.target.value);
      break

      case 'fone1':
      case 'fone2':
      case 'celular': 
        auxValues[e.target.name] = mTel(e.target.value);
      break

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  const reloadUnidades = () => {
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/orgao_unidade?fk_org=' + codigo).then(r => {
      if (r.data) {
        console.log(r.data)
        setDataUnidades(r.data)
      }
      swal.close()
    })
  }

  
  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Orgao</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>
          <TabsOrgao
            data={data}
            handleChange={handleChange}
            setData={setData}
            comboSituacao={comboSituacao}
            comboTipo={comboTipo}
            comboCidades={comboCidades}
            pk_org={codigo} 
            updateType={updateType}
            setUpdateType={setUpdateType}  
            dataUnidades={dataUnidades}
            reloadUnidades={reloadUnidades}
            setDataUnidades={setDataUnidades}
            
          />
        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RegOrgao;
